import { render, staticRenderFns } from "./EditContactSpouseForm.vue?vue&type=template&id=4ce2a6c5&"
import script from "./EditContactSpouseForm.vue?vue&type=script&lang=ts&"
export * from "./EditContactSpouseForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditContactSpouseForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports